import React, { useCallback, useEffect, useRef, useState } from 'react';

import { formatAsTimeString } from 'src/common/util';
import { Show } from 'src/common/layout';

type CountdownProps = {
  expiresAt: Date;
  onExpiration: () => void;
  text?: string;
};

const MS_TO_S_BASE = 1000; // Used to divide milliseconds to convert to seconds

export const CountdownTimer = React.memo(({ expiresAt, onExpiration, text = '' }: CountdownProps) => {
  const [timeRemaining, setTimeRemaining] = useState(
    Math.floor(new Date(expiresAt).getTime() / MS_TO_S_BASE) - Math.floor(Date.now() / MS_TO_S_BASE),
  );
  const intervalRef = useRef();

  const calculateTimeLeft = useCallback(() => {
    const expiresAtSeconds = Math.floor(new Date(expiresAt).getTime() / MS_TO_S_BASE);
    const timeNowSeconds = Math.floor(Date.now() / MS_TO_S_BASE);
    const difference = expiresAtSeconds - timeNowSeconds;

    return difference;
  }, [expiresAt]);

  useEffect(() => {
    (intervalRef as any).current = setInterval(() => {
      setTimeRemaining(calculateTimeLeft());
    }, 1000);
    return () => clearInterval((intervalRef as any).current);
  }, [calculateTimeLeft]);

  useEffect(() => {
    if (timeRemaining <= 0) {
      clearInterval(intervalRef.current);
      onExpiration();
    }
  }, [onExpiration, timeRemaining]);

  if (timeRemaining > 0) {
    return (
      <>
        <Show show={text?.length > 0}>{text}&nbsp;</Show>
        <span className="font-bold">{formatAsTimeString(timeRemaining)}</span>
      </>
    );
  }
  return <span>Time expired!</span>;
});
